import { render, staticRenderFns } from "./FenomenSelection.vue?vue&type=template&id=00ddf14d"
import script from "./FenomenSelection.vue?vue&type=script&lang=js"
export * from "./FenomenSelection.vue?vue&type=script&lang=js"
import style0 from "./FenomenSelection.vue?vue&type=style&index=0&id=00ddf14d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports